import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '@services/auth-service.service';
import { LoaderService } from '@services/loader.service';
import { Globals } from 'src/app/globals';
import { Inject } from '@angular/core';
import { MustMatch } from 'src/app/util/must-match.validator';
import { RegUser } from '../basic-reg/RegUser';

@Component({
  selector: 'app-create-password',
  standalone: true,
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    RouterLink,
    HeaderComponent,
    FooterComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CreatePasswordComponent implements OnInit {

  requestPath: string;

  heading = "Email Verification";
  subheading = "";

  cpUser = new RegUser();
  cpForm: FormGroup = new FormGroup({});
  cpSubmitted: boolean = false;
  errorMessage: string = '';

  user: RegUser = new RegUser();
  userPwd: RegUser = new RegUser();
  enablePasswordPage: boolean = false;

  verificationCode: string = '';
  id: number = 0;

  passwordVisible: boolean = false;
  confirmPasswordVisible: boolean = false;

  constructor(
    @Inject(Globals) public global: Globals,
    @Inject(AuthServiceService) public authService: AuthServiceService,
    public formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    @Inject(LoaderService) private loader: LoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.requestPath = this.global.requestPath;

    this.route.params.subscribe(params => {
      this.verificationCode = params['verificationCode'];
      this.id = params['id'];
      if (this.global.isEmpty(this.verificationCode)) {
        this.router.navigate(['/home']);
      }
    });
  }

  ngOnInit() {
    this.cpForm = this.formBuilder.group({
      userPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    }, {
      validator: MustMatch('userPassword', 'confirmPassword')
    });
  }

  ionViewDidEnter() {
    this.onReset();
    this.verifyEmail();
  }

  ionViewWillEnter() {
  }

  onReset = () => {
    this.heading = "Email Verification";
    this.enablePasswordPage = false;

    this.cpForm.reset();
    this.cpUser = new RegUser();
    this.userPwd = new RegUser();
    this.cpSubmitted = false;

    this.errorMessage = '';
  }

  verifyEmail = () => {
    this.cpUser.id = this.id;
    this.cpUser.verificationCode = this.verificationCode;
    this.loader.show("Please wait...");
    this.authService.getNoSecure('ns/common/user?' + this.requestPath + '=verifyVCode&userId=' + this.cpUser.id + "&vCode=" + this.cpUser.verificationCode + "&emailOrPhone=1")
      .subscribe((res: any) => {
        this.loader.hide();
        console.log(res);
        if (res.success) {
          //Decrypt Data
          this.enablePasswordPage = true;
          this.heading = "Set New Password";
        } else {
          this.errorMessage = res.message;
        }
        this.cdr.detectChanges();
      }, (error: any) => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  createNewPassword = () => {
    this.cpSubmitted = true;
    this.errorMessage = '';

    if (this.cpForm.invalid) {
      // console.log("Invalid form");
      return;
    }

    this.cpUser.password = window.btoa(this.userPwd.userPassword ?? '');
    this.loader.show("Please wait...");
    this.authService.postDefaultEncrypt('ns/common/user?' + this.requestPath + '=createPassword', this.cpUser)
      .subscribe((res: any) => {
        this.loader.hide();
        // console.log(res);
        if (res.success) {
          //Decrypt Data
          res.data = this.global.decryptDefault(res.data);
          this.global.saveLocalData(this.global.HIDDIN_USER_DETAILS, JSON.stringify(res.data));
          this.router.navigate(["/otp"]);
          // console.log(res.description);
        } else {
          this.errorMessage = res.message;
        }
        this.cdr.detectChanges();
      }, (error: any) => {
        this.loader.hide();
        // console.log(error);
        this.errorMessage = "Something went wrong, please try again.";
        this.cdr.detectChanges();
      });
  }

  togglePassword(id: string) {
    const password = document.querySelector('#' + id);
    if (!password) return;
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);

    if (id === 'resetPwd') {
      this.passwordVisible = !this.passwordVisible;
    } else if (id === 'confirmResetPwd') {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    }
  }

}
